import { AxiosRequestConfig } from 'axios';
import { client } from './client';

export const http = async <T>(config: AxiosRequestConfig) => {
  const { data } = await client.request<T>(config);
  return data;
};
